"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAUTH_ENDPOINT_NAMES = void 0;
exports.OAUTH_ENDPOINT_NAMES = [
    'token',
    'revocation',
    'introspection',
    'pushed_authorization_request',
];
//# sourceMappingURL=oauth-endpoint-name.js.map